import { render, staticRenderFns } from "./Procesos.vue?vue&type=template&id=0d1e487e&"
import script from "./Procesos.vue?vue&type=script&lang=js&"
export * from "./Procesos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports